<template>
  <div>
    <input type="text" v-model="title">
  </div>
  <div>
    <textarea v-model="content"></textarea>
  </div>
  <div class="center">
    <button @click="save">保存</button>
    <button @click="remove" v-if="memo.id">削除</button>
  </div>
</template>

<script>
export default {
  name: 'MemoForm',
  props: [
    'memo'
  ],
  data() {
    return {
      title: this.memo.title,
      content: this.memo.content
    }
  },
  methods: {
    save() {
      let memo = {
        title: this.title,
        content: this.content
      }

      // idが存在するか
      if(this.memo.id) {
        // props.memoで取得したidを渡す
        memo.id = this.memo.id
      }

      // store.mutations.save 保存
      this.$store.commit('save', memo)
      // トップへ遷移
      this.$router.push('/')
    },
    remove () {
      //store.mutations.delete へ memo.id 渡す
      this.$store.commit('delete', this.memo.id)
      // トップへ遷移
      this.$router.push('/')
    }
  }
}
</script>


<style scoped>
div {
  margin-bottom: 10px;
}
input[type=text] {
  width: 100%;
}
textarea {
  width: 100%;
  height: 30em;
}
button {
  width: 5em;
  margin: 3px;
}
.center {
  text-align: center;
}
</style>